'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './documentation.routes';
import {$, jQuery} from 'jquery';
import _ from "lodash";

export class DocumentationComponent {
  constructor($state, $scope, $http, appConfig) {
    $scope.$state = $state;
    $scope.settings = {};

    $http.get('/api/settings').then(res => { $scope.settings = res.data; });

    $scope.items = [
      {
        title: 'General Information',
        items: appConfig.documentation.map(x => {
          return {
            name: x.title,
            state: `documentation.${x.name}`,
            items: x.items,
            version: x.version,
            id: x.id,
            space: x.space,            
          };
        })
      }
    ];

    $scope.selectedMenu = {};

    $scope.navigateToState = item => {
      $scope.selectedMenu = item;
      $state.transitionTo(item.state);
    };

    $scope.navigateToSubItem = ($event, subItem) => {
      $event.preventDefault();
      window.jQuery([document.documentElement, document.body]).animate({
          scrollTop: window.jQuery(`#${subItem.id}`).offset().top - 75
      }, 1000);
    };

    $scope.getCurrentMenu = () => {
      let result = {};
      _.forEach($scope.items, i => {
        const state = _.find(i.items, s => s.state === $state.current.name);
        if(state)
          result = state;
      });
      return result;
    };

    $scope.$on('$viewContentLoaded', function(){
      $scope.selectedMenu = $scope.getCurrentMenu();
      window.confluenceInfo = $scope.selectedMenu;
    });
  }
}

DocumentationComponent.$inject = ['$state', '$scope', '$http', 'appConfig'];

export default angular.module('syncplicityLoginApp.documentation', [uiRouter])
  .config(routes)
  .component('documentation', {
    template: require('./static/documentation.html'),
    controller: DocumentationComponent,
    controllerAs: 'documentationCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/documentation/documentation.component.js